import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { getSubDomain } from "./shared-functions.js";

import { Container, Row, Col } from 'react-bootstrap';

import TopNavbar from "./components/common/TopNavbar.js"
// import Sidebar from "./components/common/Sidebar.js";
import Footer from "./components/common/Footer.js";
// import Privacy from "./components/legal/Privacy.js"
// import Terms from "./components/legal/Terms.js"
// import CookiePolicy from "./components/legal/CookiePolicy.js"
import NotFound from "./NotFound.js";
import Home from "./Home.js";
import Login from "./Login.js";
import Signup from "./Signup.js";
import Onboarding from "./Onboarding.js";
import Frontpage from "./Frontpage.js";
import { ProvideAuth } from "./use-firebase.js"

export default function App() {

  let subdomain = getSubDomain(window.location.host);

  return (
    <ProvideAuth>
      <Router>
        <Container fluid style={{ marginTop: 0, minHeight: '100vh', backgroundColor: '#100E15' }}>
          <TopNavbar />
          <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'stretch', marginTop: 50, marginLeft: 0, marginRight: 0 }}>
            {/* <Sidebar /> */}
            <Col style={{ height: '100vh', width: '85%', padding: 0 }}>
              <Routes>
                <Route path="/notfound" element={<NotFound />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/home" element={<Home />} />
                <Route path="/" element={<Frontpage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Col>
          </Row>
        </Container>
      </Router>
    </ProvideAuth>
  );
}
